import React from 'react'
import { Route, Switch } from 'react-router-dom'

import {
  PaginaFilasTrabalhoInstituicao,
  PaginaHistoricoTicketInstituicao
} from 'src/paginas/certificacao-institucional'
import {
  PaginaInicialCertificacao,
  PaginaCursosCertificacao,
  PaginaCadastroCursosCertificacao,
  PaginaCadastroTurmasCertificacao,
  PaginaTurmasCertificacao,
  PaginaAlunosCertificacao,
  PaginaCadastroAlunosCertificacao,
  PaginaProfessoresCertificacao,
  PaginaCadastroProfessoresCertificacao,
  PaginaMeuCadastroParceiroCertificacao,
  PaginaFilasTrabalho,
  PaginaHistoricoTicket,
  DocumentosAlunoCertificacao,
  DocumentosPPCCertificacao,
  DocumentosParceiroCertificacao,
  DocumentosProfessorCertificacao
} from 'src/paginas/parceiro-certificacao'
import { PaginaParceirosCertificacao } from 'src/paginas/parceiro-certificacao/parceiro'
import { ModoPaginaCadastro } from 'src/tipos'

const RotaBase = 'certificacao'

export const RotasParceiroCertificacao = {
  Dashboard: `/${RotaBase}`,
  MeuCadastro: `/${RotaBase}/meu-cadastro`,
  Parceiros: `/${RotaBase}/parceiros`,
  Documentos: `/${RotaBase}/documentos-parceiro`,
  FilasTrabalho: `/${RotaBase}/filas-trabalho`,
  HistoricoTicket: `/${RotaBase}/fila-trabalho-historico`
}

export const RotasCursoCertificacao = {
  Cursos: `/${RotaBase}/cursos`,
  Edicao: `/${RotaBase}/cursos/edicao`,
  Cadastro: `/${RotaBase}/cursos/cadastro`,
  DocumentosPPC: `/${RotaBase}/cursos/documentos-ppc`
}

export const RotasTurmaCertificacao = {
  Turmas: `/${RotaBase}/turmas`,
  Edicao: `/${RotaBase}/turmas/edicao`,
  Cadastro: `/${RotaBase}/turmas/cadastro`
}

export const RotasAlunoCertificacao = {
  Alunos: `/${RotaBase}/alunos`,
  Edicao: `/${RotaBase}/alunos/edicao`,
  Cadastro: `/${RotaBase}/alunos/cadastro`,
  Documentos: `/${RotaBase}/alunos/documentos`
}

export const RotasProfessorCertificacao = {
  Professores: `/${RotaBase}/professores`,
  Edicao: `/${RotaBase}/professores/edicao`,
  Cadastro: `/${RotaBase}/professores/cadastro`,
  Documentos: `/${RotaBase}/professores/documentos`
}

export const RotasCertificacaoInstitucional = {
  FilasTrabalho: `/${RotaBase}/filas-trabalho-instituicao`,
  HistoricoTicket: `/${RotaBase}/fila-trabalho-historico-instituicao`
}

export const CertificacaoRotas: React.FC = () => {
  return (
    <Switch>
      <Route exact path={RotasParceiroCertificacao.Dashboard}>
        <PaginaInicialCertificacao />
      </Route>
      <Route path={`${RotasParceiroCertificacao.MeuCadastro}/:id`}>
        <PaginaMeuCadastroParceiroCertificacao />
      </Route>
      <Route exact path={`${RotasParceiroCertificacao.Documentos}/:tipo/:id`}>
        <DocumentosParceiroCertificacao />
      </Route>
      <Route exact path={RotasParceiroCertificacao.Parceiros}>
        <PaginaParceirosCertificacao />
      </Route>
      <Route exact path={RotasCursoCertificacao.Cursos}>
        <PaginaCursosCertificacao />
      </Route>
      <Route path={`${RotasCursoCertificacao.Edicao}/:id/:modalidade?`}>
        <PaginaCadastroCursosCertificacao modo={ModoPaginaCadastro.Edicao} />
      </Route>
      <Route path={RotasCursoCertificacao.Cadastro}>
        <PaginaCadastroCursosCertificacao modo={ModoPaginaCadastro.Inclusao} />
      </Route>
      <Route exact path={RotasTurmaCertificacao.Turmas}>
        <PaginaTurmasCertificacao />
      </Route>
      <Route path={RotasTurmaCertificacao.Cadastro}>
        <PaginaCadastroTurmasCertificacao modo={ModoPaginaCadastro.Inclusao} />
      </Route>
      <Route path={`${RotasTurmaCertificacao.Edicao}/:id/:tipo?`}>
        <PaginaCadastroTurmasCertificacao modo={ModoPaginaCadastro.Edicao} />
      </Route>
      <Route exact path={RotasAlunoCertificacao.Alunos}>
        <PaginaAlunosCertificacao />
      </Route>
      <Route path={RotasAlunoCertificacao.Cadastro}>
        <PaginaCadastroAlunosCertificacao modo={ModoPaginaCadastro.Inclusao} />
      </Route>
      <Route path={`${RotasAlunoCertificacao.Edicao}/:id/:situacao?`}>
        <PaginaCadastroAlunosCertificacao modo={ModoPaginaCadastro.Edicao} />
      </Route>
      <Route exact path={RotasProfessorCertificacao.Professores}>
        <PaginaProfessoresCertificacao />
      </Route>
      <Route path={RotasProfessorCertificacao.Cadastro}>
        <PaginaCadastroProfessoresCertificacao
          modo={ModoPaginaCadastro.Inclusao}
        />
      </Route>
      <Route path={`${RotasProfessorCertificacao.Edicao}/:id/:situacao?`}>
        <PaginaCadastroProfessoresCertificacao
          modo={ModoPaginaCadastro.Edicao}
        />
      </Route>
      <Route exact path={RotasParceiroCertificacao.FilasTrabalho}>
        <PaginaFilasTrabalho />
      </Route>
      <Route path={`${RotasParceiroCertificacao.HistoricoTicket}/:idTicket`} component={PaginaHistoricoTicket} />
      <Route exact path={RotasCertificacaoInstitucional.FilasTrabalho}>
        <PaginaFilasTrabalhoInstituicao />
      </Route>
      <Route path={`${RotasCertificacaoInstitucional.HistoricoTicket}/:idTicket`} component={PaginaHistoricoTicketInstituicao} />
      <Route exact path={`${RotasAlunoCertificacao.Documentos}/:id`}>
        <DocumentosAlunoCertificacao />
      </Route>
      <Route exact path={`${RotasCursoCertificacao.DocumentosPPC}/:id`}>
        <DocumentosPPCCertificacao />
      </Route>
      <Route exact path={`${RotasProfessorCertificacao.Documentos}/:id`}>
        <DocumentosProfessorCertificacao />
      </Route>
    </Switch>
  )
}
